import {email, maxLength, minLength, required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    name: "private-data",
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                name: "",
                second_name: "",
                email: "",
                phone: "",
                recipient: 0,
                other_name: "",
                other_second_name: "",
                other_email: "",
                other_phone: "",
            },
            validationErrors: {},
        };
    },
    validations() {
        if (this.payload.recipient > 0) {
            return {
                payload: {
                    name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    second_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    email: {
                        required,
                        maxLength: maxLength(50),
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(19),
                    },
                    other_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    other_second_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    other_email: {
                        required,
                        maxLength: maxLength(50),
                        email,
                    },
                    other_phone: {
                        required,
                        minLength: minLength(19),
                    },
                },
            };
        }
        else {
            return {
                payload: {
                    name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    second_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    email: {
                        required,
                        maxLength: maxLength(50),
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(19),
                    },
                },
            };
        }
    },
    created() {
        if (this.user) {
            this.setAuthData();
        } else {
            this.setUserData();
        }
    },
    computed: {
        ...mapGetters({
            userData: `order/userInfo`,
            user: "profile/user",
        }),
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        secondNameErrors() {
            let error = [];
            if (!this.$v.payload.second_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.second_name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.second_name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.second_name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.second_name) {
                this.validationErrors.second_name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        otherNameErrors() {
            let error = [];
            if (this.payload.recipient === 0) return [];
            if (!this.$v.payload.other_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.other_name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.other_name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.other_name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.other_name) {
                this.validationErrors.other_name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        otherSecondNameErrors() {
            let error = [];
            if (this.payload.recipient === 0) return [];
            if (!this.$v.payload.other_second_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.other_second_name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.other_second_name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.other_second_name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.other_second_name) {
                this.validationErrors.other_second_name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        otherEmailErrors() {
            let error = [];
            if (this.payload.recipient === 0) return [];
            if (!this.$v.payload.other_email.$dirty) {
                return error;
            }
            if (!this.$v.payload.other_email.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.other_email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.other_email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (this.validationErrors.other_email) {
                this.validationErrors.other_email.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        otherPhoneErrors() {
            let error = [];
            if (this.payload.recipient === 0) return [];
            if (!this.$v.payload.other_phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.other_phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.other_phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.other_phone) {
                this.validationErrors.other_phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapMutations({
            changeUserInfo: "order/CHANGE_USER_INFO",
            changeStep: "order/CHANGE_STEP_BUY_FLOW",
        }),
        ...mapActions({
            fetchFilial: `deliveryMethods/GET_DELIVERY_FILIAL`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.changeStep();
            }
        },
        setAuthData() {
            this.payload.name = this.user.name;
            this.payload.last_name = this.user.second_name;
            this.payload.phone = this.user.phone;
            this.payload.email = this.user.email;
        },
        setUserData() {
            // console.log(this.userData.recipient);
            this.payload.name = this.userData.name;
            this.payload.last_name = this.userData.second_name;
            this.payload.phone = this.userData.phone;
            this.payload.email = this.userData.email;
            this.payload.recipient = this.userData.recipient;
        },
    },
};
